<template>
  <div>
    <div
      v-for="(filter, filterIndex) in filtersToDisplay"
      :key="filterIndex"
    >
      <span>{{ `${filter.criteria} ${filter.operator} ${filter.value}` }}</span>
    </div>
  </div>
</template>

<script>
import { GetDisplayValueOfPath } from "@/helpers/PlzHelper.js";

export default {
  props: {
    filters: {
      type: Array,
      required: true,
    },
    operators: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    plzFilters() {
      let criterias = this.$store.state.mindestLohnKonfiguration.Criteria;
      let plzCriterias = criterias.filter((c) => c.criteriaPlzs?.length > 0);
      let plzCriteriaIds = new Set(plzCriterias.map((c) => c.id));
      let rawFilters = this.filters.filter((f) =>
        plzCriteriaIds.has(f.criteriaId),
      );
      let criteriaGroupMap = Map.groupBy(rawFilters, (f) => f.criteriaId);

      let result = [];

      for (let [key, value] of criteriaGroupMap) {
        for (let filter of value) {
          result.push({
            criteria: plzCriterias.find((c) => c.id === key).title,
            operator: this.operators.find((o) => filter.operator === o.value)
              .displayName,
            value: this.getCriteriaValue(
              filter.criteriaId,
              filter.criteriaListEntryId,
              filter.value,
            ),
          });
        }
      }

      return result;
    },
    nonPlzFilters() {
      let criterias = this.$store.state.mindestLohnKonfiguration.Criteria;
      let plzCriterias = criterias.filter((c) => c.criteriaPlzs?.length > 0);
      let plzCriteriaIds = new Set(plzCriterias.map((c) => c.id));
      let rawFilters = this.filters.filter(
        (f) => !plzCriteriaIds.has(f.criteriaId),
      );

      let result = rawFilters.map((f) => {
        let criteria = criterias.find((c) => c.id === f.criteriaId);
        let operator = this.operators.find((o) => o.value === f.operator);
        return {
          criteria: criteria.title,
          operator: operator.displayName,
          value: f.value,
        };
      });

      return result;
    },
    filtersToDisplay() {
      return [...this.nonPlzFilters, ...this.plzFilters];
    },
  },
  created() {},
  methods: {
    getCriteriaValue(criteriaId, criteriaListEntryId, currentValue) {
      var criteriaMap = Map.groupBy(
        this.$store.state.mindestLohnKonfiguration.Criteria,
        (c) => c.id,
      );
      var criteria = criteriaMap.get(criteriaId);

      if (!criteria || criteria.length == 0) {
        return currentValue;
      }

      var listEntry = criteria[0].listEntries.filter((entry) => {
        return entry.id == criteriaListEntryId;
      });

      if (listEntry.length > 0) {
        return listEntry[0].contents.length == 0
          ? listEntry[0].code
          : listEntry[0].contents[0].text;
      }

      if (criteria[0].criteriaPlzs && criteria[0].criteriaPlzs.length > 0) {
        return GetDisplayValueOfPath(
          currentValue,
          this.$store.state.mindestLohnKonfiguration.Cities,
        );
      }

      if (currentValue) {
        return currentValue;
      }
    },
  },
};
</script>

<style></style>
